import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastsComponent } from './toasts/toasts.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { SessionTimeoutModalComponent } from './session-timeout-modal/session-timeout-modal.component';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { PhoneNumberDirective } from './directives/phone-number.directive';
import { DownloadProgressComponent } from './modals/download-progress/download-progress.component';



@NgModule({
  declarations: [ToastsComponent, ClickOutsideDirective, DatePickerComponent, VideoPlayerComponent, SessionTimeoutModalComponent, NumbersOnlyDirective, PhoneNumberDirective, DownloadProgressComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxDaterangepickerMd,
    NgxDaterangepickerMd.forRoot()

  ],
  exports : [
    ToastsComponent,
    DatePickerComponent,
    ClickOutsideDirective,
    VideoPlayerComponent,
    SessionTimeoutModalComponent,NumbersOnlyDirective,PhoneNumberDirective,DownloadProgressComponent
  ]
})
export class PluginsModule { }
